define('app/models/credit',['app/setup'], function(takhfifan) {

  takhfifan.Credit = Backbone.Model.extend({

    validation: {
      'amount': {
        min: 0,
        msg: i18n.t('amount_must_be_positive')
      }
    },

    updateAmount: function(amount) {
      var balance = this.get('balance');
      if (amount >= balance) {
        this.set('amount', balance);
        this.set('available', 0);
      } else if (amount <= 0) {
        this.set('amount', 0);
        this.set('available', balance);
      } else {
        this.set('amount', amount);
        this.set('available', balance - amount);
      }
      this.validate();
    },

    submit: function(url) {
      if (typeof url === 'undefined' || url === null) {
        return false;
      }

      var _this = this;

      $.post(url, {customer_credit: this.get('amount')*10}, function(response) {
        _this.trigger('submit:success');
      });
    },

    defaults: {
      amount: 0,
      available: 0,
      balance: 0
    }

  });

});

